/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ISocialChannel } from '../social-channel-schema';
import { socialChannelSchema } from '../social-channel-schema';

const syncDataSchema = z.object({
  synced: z.number(),
  items: z.array(socialChannelSchema),
});

export interface ISyncSocialChannelsV1Data {
  synced: number;
  items: ISocialChannel[];
}

export const syncSocialChannelsV1ResponseSchema = createApiResponseSchema(
  syncDataSchema,
) as z.ZodSchema<IAPI<ISyncSocialChannelsV1Data>>;

export type ISyncSocialChannelsV1Response = IAPI<ISyncSocialChannelsV1Data>;
